import React, { FC } from 'react';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';
import { selectedLeasesIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IReturnedOnProps {
  entryPass: ITepEntryPass;
}

export const ReturnedOn: FC<IReturnedOnProps> = ({ entryPass }) => {
  const id = useSelector(selectedLeasesIdSelector);

  const { formState, control } = useFormContext<{ returnedOn: Date }>();

  const { errors } = formState;

  const isSelected = entryPass?.id === id;
  const error = errors.returnedOn?.message;

  const disabledDate = (date: Date) => moment(date).isAfter(moment(new Date()), 'day');

  return isSelected ? (
    <Controller
      control={control}
      name="returnedOn"
      rules={{ required: fc('please select date') }}
      render={({ value, onChange }) => (
        <div className={styles.datePicker}>
          <DatePicker value={value} onChange={onChange} disabledDate={disabledDate} />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div>{moment(entryPass.lease?.returnedOn || new Date()).format('YYYY-MM-DD')}</div>
  );
};
